// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rWHX6","toggle":"styles_toggle__3eTZd","preview":"styles_preview__1mNfY"};